<template>
  <section v-on:click="sectionClicked">
    <Header class="page" :class="{hasBg: scrolled || loading}"/>
    <div class="loadingFull" v-if="loading"></div>
    <NotFound v-else-if="notFound"></NotFound>
    <div class="movie" v-else>
      <div class="movie-overlay"></div>
      <div class="cnt">
        <div class="movie-info">
          <img src="../assets/bye-logo-no-shadow.png" class="movie-logo">
          <p v-if="lang === 'id'">Nasib Anak Buah Kapal (ABK) asal Indonesia di kapal-kapal ikan
            asing di laut lepas tak senikmat hasil tangkapan mereka yang tersaji di
            restoran-restoran mahal. Kekerasan fisik, jam kerja yang panjang,
            makanan yang tidak layak...</p>
          <p v-if="lang === 'en'">It's no secret that Indonesian migrant fishers in distant
            water fishing vessels commonly report being subjected to human rights abuses and
            fisheries crimes. But, someone sitting down to eat in a high end restaurant will
            probably have no idea. Before You Eat connects the dot from ocean to plate and
            reveals the true cost of seafood. Join the movement to protect oceans
            and fishers, and watch the movie here.</p>
          <div class="genre">Documenter <span>|</span> True Story</div>
          <button class="btn primary" :class="{disabled: !canPlay, loading: savingState}"
             v-on:click="openMovie">
            <span>Watch Now</span>
          </button>
          <div class="needAccess" v-if="!canPlay">
            <template v-if="accessExpired">
              <template v-if="lang === 'id'">
                Akses kamu untuk menonton film ini sudah kadaluarsa, silahkan minta ulang
                akses untuk menonton film.
              </template>
              <template v-if="lang === 'en'">
                Your access to watch this movie has been expired, please request access again to watch the movie.
              </template>
              <a :href="`${$config.appPath}${langCode}/mau-nonton-/mau-nonton-submenu/-before-you-eat-`">
                <template v-if="lang === 'id'">
                  Minta Ulang Akses
                </template>
                <template v-if="lang === 'en'">
                  Request Movie Acccess
                </template>
              </a>
            </template>
            <template v-else>
              <template v-if="lang === 'id'">
                Kamu harus meminta akses untuk dapat menonton film ini.
              </template>
              <template v-if="lang === 'en'">
                You need to request access to watch this movie.
              </template>
              <a :href="`${$config.appPath}${langCode}/mau-nonton-/mau-nonton-submenu/-before-you-eat-`">
                <template v-if="lang === 'id'">
                  Minta Akses
                </template>
                <template v-if="lang === 'en'">
                  Request Movie Acccess
                </template>
              </a>
            </template>
          </div>
          <div class="expiryInfo" v-else-if="expiry">
            <template v-if="lang === 'id'">
              Akses ini akan berakhir pada
            </template>
            <template v-if="lang === 'id'">
              Your access will expire at
            </template>
            <b>{{expiry | moment('D MMM YYYY HH:mm')}}</b>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  name: 'home',
  components: {
    Header,
    Footer,
    NotFound,
  },
  data() {
    return {
      loading: true,
      scrolled: false,
      notFound: false,
      canPlay: false,
      accessExpired: false,
      expiry: null,
      savingState: false,

      lang: 'en',
      langCode: 'en-us',
    };
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
    openMovie() {
      if (!this.canPlay) return;
      const { code } = this.$route.params;
      const { key } = this.$route.query;
      this.savingState = true;
      this.$http.post(this.$config.uri('misc/1/start-watch'), { key }).then((r) => {
        this.savingState = false;
        this.$router.push(`${this.$config.appPath}${this.langCode}/watch/${code}/play?key=${key}`);
      });
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    const { code } = this.$route.params;
    if (code !== 'before-you-eat-the-movie') {
      this.loading = false;
      this.notFound = true;
      return;
    }

    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    /**
     * Validate language
     *
     */
    if (!this.$route.params.lang) {
      let langCode = window.navigator.userLanguage || window.navigator.language;
      langCode = (langCode === 'id-ID') ? 'id' : 'en';
      const countryCode = (langCode === 'id') ? 'id' : 'us';
      window.location.href = `/${langCode}-${countryCode}`;
    }

    /**
     * Validate key
     *
     */
    const { key } = this.$route.query;
    this.$http.post(this.$config.uri('misc/1/validate-movie-access'), { key }).then((r) => {
      this.loading = false;
      if (r.data.status === 200) {
        this.canPlay = true;
        this.expiry = r.data.expired;
      } else if (r.data.status === 400) {
        this.canPlay = false;
        this.accessExpired = true;
      } else {
        this.canPlay = false;
      }
    });
  },
};
</script>

<style scoped lang="scss">
.movie{
  height: 100vh;
  background-image: url(../assets/bye-home-bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: -110px;
  position: relative;
  .movie-overlay{
    position: absolute;
    left: 0; top: 0; bottom: 0; right: 0;
    background-image: linear-gradient(64deg, rgba(0,0,0,.84), transparent);
  }
  .cnt{
    position: relative;
    z-index: 3;
    height: 100%;
    display: flex;
    align-items: center;
    @media (max-width: 1540px) {
      max-width: 1180px;
    }
    @media (max-width: 1340px) {
      max-width: 980px;
    }
    @media (max-width: 1260px) {
      margin: 0 auto;
    }
    @media (max-width: 1100px) {
      max-width: 840px;
    }
    .movie-info{
      max-width: 460px;
      @media (max-width: 940px) {
        margin: 0 auto;
        padding: 0 20px;
        text-align: center;
      }
      .movie-logo{
        height: 180px;
        margin: 0 0 24px;
        @media (max-width: 640px) {
          height: 140px;
        }
      }
      p{
        color: #fff;
        font-size: 18px;
        line-height: 1.4;
        opacity: .76;
        font-weight: 300;
        margin: 0 0 10px;
        @media (max-width: 640px) {
          font-size: 16px;
          line-height: 1.3;
        }
      }
      .expiryInfo{
        color: #fff;
        opacity: .76;
        font-size: 15px;
        margin-top: 16px;
      }
      .needAccess{
        border: red 1px solid;
        line-height: 1.2;
        color: #fff;
        text-align: center;
        padding: 10px 20px;
        border-radius: 5px;
        width: 302px;
        margin: 16px 0 0;
        @media (max-width: 940px) {
          width: 100%;
          margin: 16px auto 0;
          padding: 0;
          border: none;
          color: red;
        }
      }
      .genre{
        color: #fff;
        font-size: 16px;
        text-transform: uppercase;
        font-weight: 600;
        opacity: .76;
        margin: 0 0 24px;
        span{
          margin: 0 4px;
        }
      }
      .btn.primary{
        padding: 14px 80px 11px;
        font-size: 26px;
        letter-spacing: 1.4px;
        &.loading{
          outline: none !important;
          box-shadow: none !important;
        }
        @media (max-width: 680px) {
          padding: 12px 60px 9px;
          font-size: 20px;
        }
        span{
          position: relative;
          display: inline-block;
          padding-left: 36px;
          @media (max-width: 680px) {
            padding-left: 26px;
          }
          &:before{
            content: "";
            position: absolute;
            left: 0; top: 0; bottom: 3px;
            width: 18px;
            background-image: url(../assets/play-icon-white.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            @media (max-width: 680px) {
              background-size: 14px auto;
            }
          }
        }
        &.disabled{
          span{
            &:before{
              background-image: url(../assets/play-icon.png);
              opacity: .2;
            }
          }
        }
      }
    }
  }
  @media (max-width: 1460px) {
    margin-bottom: -130px;
  }
  @media (max-width: 1160px) {
    margin-bottom: -150px;
  }
  @media (max-width: 960px) {
    margin-bottom: -80px;
  }
  @media (max-width: 540px) {
    margin-bottom: -40px;
  }
}
</style>
